if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}
		sliders.forEach((slider, index) => {
			if (slider?.swiper) return;

			const productSlider = new Swiper(slider, {
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: true,
				990: {
					allowTouchMove: false,
				},
			});

			// BJP: sur desktop, retire la slide a-plat dupliquee (le survol gere deja le crossfade) => pas de doublon. Sur mobile, on la garde en position 2.
			try {
				if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
					const dupe = slider.querySelector('.swiper-slide.js-hover-dupe');
					if (dupe) {
						const idx = Array.prototype.indexOf.call(
							slider.querySelectorAll('.swiper-wrapper > .swiper-slide'),
							dupe
						);
						if (idx > -1) productSlider.removeSlide(idx);
					}
				}
			} catch (e) {}
		});
	};

	initSlider();
	loadeMoreSlider_G = initSlider;

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});

	// BJP: les produits recommandes ("Completez votre look") sont injectes en AJAX par
	// <product-recommendations>, sans declencher shopify:section:load => le slider n'etait
	// jamais initialise sur ces cartes (a-plat dupliquee non retiree). On observe le DOM et
	// on (re)initialise des qu'une carte .product-card-js est ajoutee.
	if ('MutationObserver' in window) {
		let scheduled = false;
		const mo = new MutationObserver((mutations) => {
			if (scheduled) return;
			for (const m of mutations) {
				for (const node of m.addedNodes) {
					if (node.nodeType === 1 && (node.matches?.('.product-card-js') || node.querySelector?.('.product-card-js'))) {
						scheduled = true;
						requestAnimationFrame(() => { scheduled = false; initSlider(); });
						return;
					}
				}
			}
		});
		mo.observe(document.body, { childList: true, subtree: true });
	}
})();
